import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../contexts/ToastContext';
import AssociativeAppShell from '../../components/AssociativeAppShell';
import SupportBackLink from '../../components/support/SupportBackLink';
import NotificationPreferences from '../../components/support/NotificationPreferences';
import { representativeSupportApi } from '../../services/adapters/representativeSupportApi';
import { getMyProfile, removeRepresentativeToken } from '../../services/representativeService';

interface RepProfile {
  _id: string;
  nome: string;
  cognome: string;
  tipo: 'interno' | 'esterno';
  caricaPrincipale?: string;
  foto?: string;
  associatesAccess?: boolean;
  permissions: { name: string; description: string }[];
}

// Preferenze email dei ticket per i rappresentanti (Task 25). Il profilo serve
// alla shell, con le stesse guardie delle altre pagine dell'area (senza
// `representative_token` si torna all'accesso associati).
const AssociativeSupportNotifiche: React.FC = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [profile, setProfile] = useState<RepProfile | null>(null);
  const canLive = profile?.permissions?.some((p) => p.name === 'associativa.live.publish') ?? false;

  useEffect(() => {
    const token = localStorage.getItem('representative_token');
    if (!token) {
      navigate('/accesso-associati');
      return;
    }
    const loadProfile = async () => {
      try {
        const res = await getMyProfile();
        if (res.success) setProfile(res.data);
      } catch (err: any) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          removeRepresentativeToken();
          navigate('/accesso-associati');
          return;
        }
        toast.error('Errore caricamento profilo');
      }
    };
    loadProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <AssociativeAppShell
      route="supporto"
      nome={profile?.nome}
      cognome={profile?.cognome}
      caricaPrincipale={profile?.caricaPrincipale}
      tipo={profile?.tipo}
      foto={profile?.foto}
      associatesAccess={profile?.associatesAccess}
      canLive={canLive}
    >
      <div className="page fade-in">
        <SupportBackLink to="/area-associativa/supporto" label="Torna al supporto" />
        <NotificationPreferences api={representativeSupportApi} variant="associative" />
      </div>
    </AssociativeAppShell>
  );
};

export default AssociativeSupportNotifiche;
